/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_IssuedInputs */

const vi_einvoice_issued = /** @type {(inputs: Einvoice_IssuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất HĐĐT`)
};

/**

* @param {Einvoice_IssuedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_issued = /** @type {((inputs?: Einvoice_IssuedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_IssuedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_issued(inputs)
});